module.exports = __webpack_public_path__ + "static/media/Xinyan.3deca8e7.png";